import { Component, Input, OnInit } from '@angular/core';

import { BrandColor } from '../../constants/brand-color.enum';
import { FileType } from '../../models/file-item.model';
import { CapabilitiesService } from '../../shared-context/capabilities.service';
import { AppSpecificResource, LocService } from '../../shared-context/loc.service';

import './create-location.component.css';

@Component({
    selector: 'ohp-create-location',
    templateUrl: './create-location.component.html'
})
export class CreateLocationComponent implements OnInit {

    @Input() public app: FileType;

    @Input() public showMargin?: boolean;

    @Input() public cssClass?: string;

    public createLocation: string;
    public createLocationPrompt: string;
    public oneDriveColor: string;
    public fluentRefresh: boolean;

    constructor(
        private readonly capabilitiesService: CapabilitiesService,
        private readonly locService: LocService
    ) {
    }

    public ngOnInit() {
        // TODO: Support alternate save locations
        this.createLocation = this.locService.BrandOneDrive;
        // Temporarily disable documents path array. Replace above with below when we reach agreement on document creation location.
        //this.createLocation = PathArrayFormatter.Format([this.locService.BrandOneDrive, this.locService.OneDriveRootFolderName], this.contextService.isRtl);
        this.createLocationPrompt = this.locService.appResource(AppSpecificResource.CreateNewLocationPrompt, this.app);
        this.oneDriveColor = BrandColor.OneDrive;
        this.fluentRefresh = this.capabilitiesService.capabilities.fluentRefresh;
    }
}
